// extracted by css-extract-rspack-plugin
export default {"Body":"Body-sQlK3h","body":"Body-sQlK3h","Close":"Close-hxsHbG","close":"Close-hxsHbG"};